import React from 'react';
import { useInstantSearch } from 'react-instantsearch';

function SearchRefreshWrapper({
  children,
  refreshRef,
}: {
  children: React.ReactNode;
  refreshRef: React.MutableRefObject<(() => Promise<void>) | null>;
}) {
  const { refresh } = useInstantSearch();

  React.useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    let settlePending: (() => void) | undefined;

    // eslint-disable-next-line no-param-reassign
    refreshRef.current = () =>
      new Promise<void>(resolve => {
        clearTimeout(timeoutId);
        settlePending?.();
        settlePending = resolve;
        // Delay so Algolia has time to index the change
        timeoutId = setTimeout(() => {
          settlePending = undefined;
          refresh();
          resolve();
        }, 1500);
      });

    return () => {
      clearTimeout(timeoutId);
      settlePending?.();
      // eslint-disable-next-line no-param-reassign
      refreshRef.current = null;
    };
  }, [refresh, refreshRef]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default SearchRefreshWrapper;
